module.exports = __webpack_public_path__ + "static/media/layout-4.2275fbe6.svg";